import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "width": 1000,
      "title": _vm.t('查看日志')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-skeleton', {
    attrs: {
      "loading": _vm.loading,
      "active": ""
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "columns": _vm.columns,
      "data-source": _vm.dataList
    },
    scopedSlots: _vm._u([{
      key: "log_content",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('div', {
          staticStyle: {
            "word-break": "break-word",
            "white-space": "pre-wrap"
          }
        }, [_vm._v(_vm._s(record.log_content || '--'))])]);
      }
    }])
  }), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "fbu-analyse-name": $t("\u5173\u95ED")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('关闭')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };